import { styled } from "goober";
import { useEffect, useState, type ReactNode } from "react";
import { config } from "../environment";
import { licensePath } from "../lib/apiPaths";
import { SignInLayout } from "./SignIn/shared";
import { Text } from "./Text";

// The kinds of the server's LicenseStatus (services/shared/license/license.ts);
// the gate needs only the kind, not the claims.
type LicenseStatusKind = "missing" | "invalid" | "valid" | "expired";

const TakeoverBody = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const TAKEOVER_TITLES = {
  expired: "3B license has expired",
  missing: "No 3B license applied",
  invalid: "3B license could not be verified",
} as const;

export function LicenseGate({ children }: { children: ReactNode }) {
  // A failed fetch stays in the loading state (null) rather than reporting
  // "missing": missing takes over the whole app, which a transient API error
  // must never do.
  const [kind, setKind] = useState<LicenseStatusKind | null>(null);
  useEffect(() => {
    let cancelled = false;
    void fetch(licensePath(), { credentials: "include" })
      .then(async (response) => {
        if (!response.ok) return;
        const body = (await response.json()) as {
          status: { kind: LicenseStatusKind };
        };
        if (!cancelled) setKind(body.status.kind);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (kind === null || kind === "valid") return children;

  return (
    <SignInLayout title={TAKEOVER_TITLES[kind]}>
      <TakeoverBody>
        <Text variant="text-regular" color="var(--text-secondary)">
          Please contact Tines support or your account team.
        </Text>
        <Text variant="code-regular" color="var(--text-secondary)">
          Version: {config.gitSha}
        </Text>
      </TakeoverBody>
    </SignInLayout>
  );
}
